import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./setup/i18n";
import createVuetify from "./setup/vuetify";
import "@socotec.io/socio-vue-components/style.css";

import SocioManifest from "../socio-manifest.json";
import PackageJson from "../package.json";
import SocioVueComponents, {
  initializeTracingAndLogging,
} from "@socotec.io/socio-vue-components";
import { plugin as unleashPlugin } from "@unleash/proxy-client-vue";
import { createORM } from "pinia-orm";
import { createPinia } from "pinia";
import * as Sentry from "@sentry/vue";
import { getDefaultSentryConfig } from "@socotec.io/socio-grpc-api/configs";
import { createSentryPiniaPlugin } from "@sentry/vue";

const config = {
  url: import.meta.env.VITE_APP_UNLEASH_URL,
  clientKey: import.meta.env.VITE_APP_UNLEASH_PROXY_SECRETS,
  refreshInterval: 15,
  appName: import.meta.env.VITE_APP_SOCIO_GRPC_API_ENV,
};

const faroSettings = {
  enableTelemetry: import.meta.env.VITE_APP_ENABLE_TELEMETRY,
  grafanaApiKey: import.meta.env.VITE_APP_GRAFANA_API_KEY,
  collectorUrl: import.meta.env.VITE_APP_COLLECTOR_URL,
  propagateUrls: import.meta.env.VITE_APP_PROPAGATE_URLS,
  grpcApiEnv: import.meta.env.VITE_APP_SOCIO_GRPC_API_ENV,
  faroLogLevel: import.meta.env.VITE_APP_FARO_LOG_LEVEL,
};

initializeTracingAndLogging(SocioManifest, PackageJson, faroSettings, {
  router,
});

const app = createApp(App);
Sentry.init(
  getDefaultSentryConfig({
    app,
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    router,
    release: `test-infra@${import.meta.env.VITE_APP_VERSION}`,
    enabled: import.meta.env.MODE !== "development",
    environment: import.meta.env.VITE_APP_SOCIO_GRPC_API_ENV,
  }),
);

const pinia = createPinia().use(createORM());
pinia.use(createSentryPiniaPlugin());

app.use(router);
app.use(pinia);
app.use(unleashPlugin, { config });
app.use(i18n);
app.use(createVuetify(i18n));
app.use(SocioVueComponents, i18n);

app.mount("#app");
